import { render, staticRenderFns } from "./PsCriteriaFilters.vue?vue&type=template&id=53bc56cf&scoped=true&"
import script from "./PsCriteriaFilters.vue?vue&type=script&lang=js&"
export * from "./PsCriteriaFilters.vue?vue&type=script&lang=js&"
import style0 from "./PsCriteriaFilters.vue?vue&type=style&index=0&id=53bc56cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bc56cf",
  null
  
)

export default component.exports